import script from "./ContentWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./ContentWrapper.vue?vue&type=style&index=0&id=4bea461a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bea461a"]])

export default __exports__